import combineReducers from "../../../utilities/combine-reducers";
import createReducer from '../../../utilities/create-reducer';
import * as actions from './actions';
import { ProductsStatus, ItemCommentsStatus, CategoryCommentsStatus } from './constants';

const productsStatus = createReducer({
  [actions.SET_PRODUCTS_STATUS]: (state, { payload }) => payload
}, ProductsStatus.IDLE);

const productsData = createReducer({
  [actions.SET_PRODUCTS_DATA]: (state, { payload }) => payload
}, ProductsStatus.IDLE);

const itemCommentsStatus = createReducer({
  [actions.SET_ITEM_COMMENTS_STATUS]: (state, { payload }) => payload
}, ItemCommentsStatus.IDLE);

const itemCommentsData = createReducer({
  [actions.SET_ITEM_COMMENTS_DATA]: (state, { payload }) => payload
}, ItemCommentsStatus.IDLE);

const categoryCommentsStatus = createReducer({
  [actions.SET_CATEGORY_COMMENTS_STATUS]: (state, { payload }) => payload
}, CategoryCommentsStatus.IDLE);

const categoryCommentsData = createReducer({
  [actions.SET_CATEGORY_COMMENTS_DATA]: (state, { payload }) => payload
}, CategoryCommentsStatus.IDLE);

const isStockOrder = createReducer({
  [actions.SET_IS_STOCK_ORDER]: (state, { payload }) => payload
}, ProductsStatus.IDLE);

export default combineReducers({
  productsStatus,
  productsData,
  itemCommentsStatus,
  itemCommentsData,
  categoryCommentsStatus,
  categoryCommentsData,
  isStockOrder
});
